var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 5.08285H10.9167M14.2501 5.08285V1.74952M14.2501 5.08285C14.2501 5.08285 12.8194 3.39102 12.2977 2.86852C9.69358 0.265182 5.47358 0.265182 2.86941 2.86852M0.916748 10.0828H4.25008M0.916748 10.0828V13.4162M0.916748 10.0828C0.916748 10.0828 2.34741 11.7747 2.86908 12.2972C5.47325 14.9005 9.69325 14.9005 12.2974 12.2972",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.e0d61dd5393c554a0bea1c3e83824be2.svg";
export { ForwardRef as ReactComponent };